export class ChangeAvailability{
  chargePointEVSEId: number;
  reason: string;
  availType: string;
}